// import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { ru } from 'vuetify/lib/locale';
import '@mdi/font/css/materialdesignicons.css';
import icons from '@/assets/icons/';

// Vue.use(Vuetify, {
//   components: { VSelect },
// });

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    values: { ...icons },
  },
  lang: {
    locales: { ru },
    current: 'ru',
  },
  theme: {
    themes: {
      light: {
        primary: '#3f51b5',
        secondary: '#464555',
        superdark: '#232328',
        success: '#81b583',
        // primary: '#A3D3E4', c dribbble
      },
      dark: {
        primary: '#3f51b5',
        secondary: '#464555',
        superdark: '#232328',
        success: '#81b583',
      },
    },
    options: {
      customProperties: true,
    },
  },
});
